var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContractEdit2 = function SvgContractEdit2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "contractEdit2_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#contractEdit2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 7h7c.283 0 .52.096.712.287.192.192.288.43.288.713s-.096.52-.288.713A.968.968 0 0 1 17 9h-7a.968.968 0 0 1-.713-.287A.968.968 0 0 1 9 8c0-.283.096-.52.287-.713A.968.968 0 0 1 10 7Zm0 3h7c.283 0 .52.096.712.287.192.192.288.43.288.713s-.096.52-.288.713A.968.968 0 0 1 17 12h-7a.967.967 0 0 1-.713-.287A.968.968 0 0 1 9 11c0-.283.096-.52.287-.713A.967.967 0 0 1 10 10Zm2 12H6a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 3 19v-2c0-.283.096-.52.288-.712A.967.967 0 0 1 4 16h2V4c0-.55.196-1.02.588-1.413A1.926 1.926 0 0 1 8 2h11c.55 0 1.02.196 1.413.587C20.803 2.98 21 3.45 21 4v7.025a3.783 3.783 0 0 0-2 .35V4H8v12h6l-2 2H5v1c0 .283.096.52.287.712.192.192.43.288.713.288h6v2Zm2-1v-1.65c0-.133.025-.263.075-.388a.999.999 0 0 1 .225-.337l5.225-5.2c.15-.15.317-.258.5-.325a1.6 1.6 0 0 1 .55-.1 1.504 1.504 0 0 1 1.075.45l.925.925c.133.15.238.317.313.5.074.183.112.367.112.55 0 .183-.033.37-.1.563a1.342 1.342 0 0 1-.325.512l-5.2 5.2c-.1.1-.212.175-.337.225-.125.05-.255.075-.388.075H15a.968.968 0 0 1-.713-.288A.968.968 0 0 1 14 21Zm1.5-.5h.95l3.025-3.05-.45-.475-.475-.45-3.05 3.025v.95Zm3.525-3.525-.475-.45.925.925-.45-.475Z",
    fill: "#40424C"
  }))));
};
export default SvgContractEdit2;